import { Button, Form, Menu, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import PageContainer from '../../common/PageContainer';
import './Listing.scss';
import { TextField } from '../../common/FormFields';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';

const ListingPage = ({ currentListing }) => {
  const getPage = () => (
    <PageContainer>
      <Menu borderless attached="top">
        <Menu.Item header>{currentListing.name}</Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <Button labelPosition="right" content="Save" icon="save" positive />
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Segment attached>
        <Form size="mini" widths="equal">
          <Form.Group>
            <TextField label="Firm" />
            <TextField label="Listing type" />
            <TextField label="All listings URL" />
            <TextField label="Ga category" />
          </Form.Group>
          <Form.Group>
            <TextField label="Title override 1" />
            <TextField label="Title override 2" />
          </Form.Group>
          <Form.Group>
            <TextField label="Target path" />
            <TextField label="Target series" />
            <TextField label="Start date" />
            <TextField label="End date" />
          </Form.Group>
        </Form>
      </Segment>

      <div className="add-listing-controls">
        <Button content="Add listing" size="small" positive icon="plus" labelPosition="right" />
      </div>

      <div className="showcase-forms"></div>
    </PageContainer>
  );

  return <>{currentListing && getPage()}</>;
};

const mapStateToProps = state => ({
  listings: selectors.getListings(state),
  currentListing: selectors.getCurrentListing(state),
});

const mapDispatchToProps = dispatch => ({
  getAdSlotById: bindActionCreators(actions.adSlot.getAdSlotById, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListingPage);
